module.exports = __webpack_public_path__ + "img/img_nav_sale-w.8069142e.svg";